import ReactDOM from 'react-dom/client';
import { MainProvider } from '@features/MainProvider';
import { App } from './App';
import './index.css';
import * as Sentry from '@sentry/react';
import React from 'react';
import { Routes, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

Sentry.init({
    dsn: 'https://0393fa43b06141a6a16d2dee8e5cd01f@o4505285597003776.ingest.sentry.io/4505511636107264',
    integrations: [
        new Sentry.BrowserTracing({
            routingInstrumentation: Sentry.reactRouterV6Instrumentation(
                React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes
            ),
        }),
        new Sentry.Replay({
            networkDetailAllowUrls: [window.location.origin],
        }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, // Capture 30% of the transactions, see how that scales with usage.
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%.
    replaysOnErrorSampleRate: 1.0, // sample rate is 100% when sampling sessions where errors occur.
    environment: import.meta.env.DEV ? 'dev' : 'prod',
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

root.render(
    <MainProvider>
        <App SentryRoutes={SentryRoutes} />
    </MainProvider>
);
